const Divisions = [
  "Allikondaar",
  "Aalkoozhnaeru",
  "Allkulanelaru",
  "Ambukolnaeru",
  "Ambugulnar",
  "Annelaar",
  "Appukoldhaar",
  "Aranganathar",
  "Baanilaar",
  "Baalelaar",
  "Baalilaar",
  "Baaniyaar",
  "Bakthimallanaar",
  "Balithaar",
  "Bojjelaar",
  "Chinnukotlaar",
  "Enthelaar",
  "Gudigelaar",
  "Irumaner",
  "Kadubelar",
  "Kallukotlaar",
  "Kappelaar",
  "Kanjalakutlaar",
  "Kenjalakudithaar",
  "Kenjalukuthidaar",
  "Koradhaar",
  "Laddhekaar",
  "Malaler",
  "Maalidhaar",
  "Maralelaar",
  "Malyathavar",
  "Minjilar",
  "Muchaladhaar",
  "Muthaladavaru",
  "Muthaledar",
  "Muthundhar",
  "Pannethar",
  "Pavalathar",
  "Pawthamalner",
  "Pojaler",
  "Sevvelar",
  "Sidhukoludhaar",
  "Thubbaelaar",
  "Thubbelar",
];

export default Divisions;
